import { createContext, useEffect, useState } from 'react';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useDelivertyUser } from 'hooks/useDelivertyUser';
import { useRouter } from 'next/router';
import __cloneDeep from 'lodash/cloneDeep';

export const RedlContext = createContext({});

const FILE_TREE_CACHE_EXPIRE_TIME = 7776000000;

const RedlProvider = (props) => {
    const [redlDatabaseStructure, setRedlDatabaseStructure] = useState(null);
    const [redlMetadataStructure, setRedlMetadataStructure] = useState(null);
    const [zoom, setZoom] = useState(100);
    const [showRightSidePanel, setShowRightSidePanel] = useState(null);
    const [showLayout, setShowLayout] = useState(false);
    const [hidePreview, setHidePreview] = useState(false);
    const [toastText, setToastText] = useState('');
    const router = useRouter();
    const { getRedlPageRawLayout, getRedlPageMetadata } = useRedlMetadata(router.pathname);
    const { userData } = useDelivertyUser();
    const redlPageRawLayout = getRedlPageRawLayout();
    const redlPageMetadata = getRedlPageMetadata();
    const [scrollPercentage, setScrollPercentage] = useState(0);
    const [fileTree, setFileTree] = useState("redl");
    const fileTreeLocalStorageName = `ccma_webapp_${userData?.usuari}_fileTree`;

    useEffect(() => {
        if (redlPageRawLayout?.structure && !redlDatabaseStructure) {
            setRedlDatabaseStructure(__cloneDeep(redlPageRawLayout.structure));
        }
    }, [redlPageRawLayout, redlDatabaseStructure]);

    useEffect(() => {
        if (redlPageMetadata?.structure) {
            setRedlMetadataStructure(__cloneDeep(redlPageMetadata.structure));
        }
    }, [redlPageMetadata]);

    useEffect(() => {
        document.getElementById('__mainContent').style.zoom = `${zoom}%`;
    }, [zoom]);

    const getNewFileTree = (now) => ({
        openedPaths: [],
        lastOpenPath: null,
        expire: now + FILE_TREE_CACHE_EXPIRE_TIME
    });

    useEffect(() => {
        if (userData?.usuari) {
            const fileTreeString = localStorage.getItem(fileTreeLocalStorageName);
            const fileJson = JSON.parse(fileTreeString);
            const timeNow = new Date().getTime();
            let finalJson;

            if (fileTreeString && timeNow < fileJson.expire) {
                fileJson.expire = timeNow + FILE_TREE_CACHE_EXPIRE_TIME;
                finalJson = fileJson;
            } else {
                finalJson = getNewFileTree(timeNow);
            }
            setFileTree(finalJson);
            localStorage.setItem(fileTreeLocalStorageName, JSON.stringify(finalJson));
        }
    }, [userData]);

    const value = {
        zoom,
        setZoom,
        showRightSidePanel,
        setShowRightSidePanel,
        showLayout,
        setShowLayout,
        hidePreview,
        setHidePreview,
        redlDatabaseStructure,
        toastText,
        setToastText,
        scrollPercentage,
        setScrollPercentage,
        redlMetadataStructure,
        fileTree,
        setFileTree,
        fileTreeLocalStorageName,
        FILE_TREE_CACHE_EXPIRE_TIME
    };

    return (
        <RedlContext.Provider value={value}>
            {props.children}
        </RedlContext.Provider>
    );
};

export default RedlProvider;
